module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black-56c360192e01ae3695f3b988bf645d64.svg";